export const PAGE_DECREMENT_ADJUSTMENT = 1;

export const getPage = () => {
  const page = new URLSearchParams(window.location.search).get('page');

  return page ? Number.parseInt(page) - PAGE_DECREMENT_ADJUSTMENT : null;
};

export const scrollToTop = () =>
  window.requestAnimationFrame(() => window.scrollTo(0, 0));

export const scrollToFilters = (router, delay = 0) => {
  // Check if we're at the top of the page or header is visible
  const isHeaderVisible = window.scrollY < window.innerHeight * 0.5;

  if (isHeaderVisible) {
    window.requestAnimationFrame(() => window.scrollTo(0, 0));
  }
};
